import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { superApi } from "@/api/endpoints/super";
import { Icon } from "@/components/Icon";

export function SuperAuditLogsPage(): JSX.Element {
  const [page, setPage] = useState(1);
  const [action, setAction] = useState("");
  const [tenantId, setTenantId] = useState("");

  const query = useQuery({
    queryKey: ["super", "audit-logs", { page, action, tenantId }],
    queryFn: () =>
      superApi.auditLogs({
        page,
        page_size: 30,
        action: action || undefined,
        tenant_id: tenantId || undefined,
      }),
  });
  const totalPages = Math.max(1, Math.ceil((query.data?.total ?? 0) / 30));

  return (
    <div className="page" data-testid="super-audit-logs">
      <div className="page-head">
        <div>
          <div className="page-title">Audit log · platform</div>
          <div className="page-sub">All workspace and platform events.</div>
        </div>
      </div>

      <div className="filters-bar">
        <div className="search-input">
          <Icon name="search" size={14} />
          <input
            value={action}
            onChange={(e) => {
              setAction(e.target.value);
              setPage(1);
            }}
            placeholder="Filter by action"
          />
        </div>
        <input
          className="field-input mono"
          style={{ width: 240, height: 34 }}
          value={tenantId}
          onChange={(e) => {
            setTenantId(e.target.value);
            setPage(1);
          }}
          placeholder="Filter by tenant id"
          aria-label="Tenant id filter"
        />
      </div>

      <div className="card">
        <div
          className="table-row-head"
          style={{ gridTemplateColumns: "180px 220px 1fr 1fr 80px" }}
        >
          <div>Time</div>
          <div>Action</div>
          <div>Actor</div>
          <div>Tenant</div>
          <div>Imp.</div>
        </div>
        {query.data?.items.map((a) => (
          <div
            key={a.id}
            className="list-row"
            style={{ gridTemplateColumns: "180px 220px 1fr 1fr 80px" }}
          >
            <div className="mono" style={{ fontSize: 11, color: "var(--text-3)" }}>
              {new Date(a.created_at).toLocaleString()}
            </div>
            <div className="audit-action">{a.action}</div>
            <div className="mono" style={{ fontSize: 12 }}>
              {a.actor_email ?? "—"}
            </div>
            <div className="mono" style={{ fontSize: 12 }}>
              {a.tenant_slug ?? <span style={{ color: "var(--text-3)" }}>platform</span>}
            </div>
            <div>
              {a.impersonation_session_id ? (
                <span className="chip chip-warning">imp</span>
              ) : null}
            </div>
          </div>
        ))}
        {(query.data?.items.length ?? 0) === 0 ? (
          <div className="empty">No matching events.</div>
        ) : null}
        <div className="pagination">
          <span>
            Page {page} of {totalPages} · {query.data?.total ?? 0} events
          </span>
          <div style={{ display: "flex", gap: 6 }}>
            <button
              className="btn btn-outline btn-sm"
              disabled={page <= 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            >
              Previous
            </button>
            <button
              className="btn btn-outline btn-sm"
              disabled={page >= totalPages}
              onClick={() => setPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
